import { styled } from '@mui/material'
import { memo } from 'react'
import { useDispatch } from 'react-redux'
import { updateModal } from 'store/app/actions/modalActions'
import { useWeb3Connected } from 'store/web3/hooks'
import { Flex } from 'styles'
import { useWeb3React } from '@web3-react/core'
import { useLinkConnected } from 'store/link/hooks'

export const UserOrderConnectWrap = styled(Flex)`
  /* height: 36px; */
  font-size: 12px;
  color: ${({ theme }) => theme.color.text60};
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  .connect {
    display: inline-flex;
    align-items: center;
    height: 32px;
    color: rgba(160, 238, 9, 1);
    cursor: pointer;
    margin-right: 5px;
    padding: 0 16px;
    border-radius: 16px;
    transition: all 0.3s ease-in-out;
    &:hover {
      color: rgba(199, 255, 92, 1);
      background-color: rgba(58, 80, 25, 1);
    }
  }
`

export const UserOrderConnect = memo(() => {
  const dispatch = useDispatch()
  const web3Connected = useWeb3Connected()
  const isLinkConnected = useLinkConnected()
  const { isActive = false, account = '' } = useWeb3React()

  const handleClick = () => {
    if (!web3Connected) {
      dispatch(updateModal({ modal: 'wallets', open: true }))
    }
  }

  if (!isActive || account === '') {
    return (
      <UserOrderConnectWrap>
        <span className="connect" onClick={handleClick}>
          Connect Wallet
        </span>
      </UserOrderConnectWrap>
    )
  }
  if (!isLinkConnected) {
    return (
      <UserOrderConnectWrap>
        <span
          className="connect"
          onClick={() => {
            dispatch(updateModal({ modal: 'verify', open: true }))
          }}
        >
          Connect ZKEX Account
        </span>
      </UserOrderConnectWrap>
    )
  }
  return <></>
})
